import { render, staticRenderFns } from "./ActionIconButton.vue?vue&type=template&id=4f15a42b"
import script from "./ActionIconButton.vue?vue&type=script&lang=js"
export * from "./ActionIconButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports